import { render, staticRenderFns } from "./my-essays.vue?vue&type=template&id=63bfbab2&scoped=true"
import script from "./my-essays.vue?vue&type=script&lang=js"
export * from "./my-essays.vue?vue&type=script&lang=js"
import style0 from "./my-essays.vue?vue&type=style&index=0&id=63bfbab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bfbab2",
  null
  
)

export default component.exports